import React from 'react'
import styled from 'styled-components'

import { FooterLinksGroupDetails, FooterMenuEntry } from '../FooterLinks'
import * as Styled from './styled'

export type FooterLinksMobileGroupDetails = Omit<FooterLinksGroupDetails, 'links'> & {
  links: Array<FooterMenuEntry | { text: string }>
}

export interface FooterLinksMobileProps {
  className?: string
  groups: FooterLinksMobileGroupDetails[]
}

const FooterLinksMobile: React.FC<FooterLinksMobileProps> = ({ className, groups }) => {
  return (
    <div className={className}>
      {groups.map((itemGroup) => (
        <Styled.FooterAccordion key={itemGroup.id}>
          <Styled.FooterAccordionSummary
            expandIcon={<Styled.FooterExpandIcon />}
            aria-label="Expand"
          >
            {itemGroup.heading}
          </Styled.FooterAccordionSummary>
          <Styled.FooterAccordionDetails>
            <Styled.AccordionItemList>
              {itemGroup.links.map((item, index) => (
                <Styled.AccordionItem key={'text' in item ? item.text : index}>
                  {'text' in item ? (
                    <Styled.AccordionItemText>{item.text}</Styled.AccordionItemText>
                  ) : (
                    <Styled.LinkEntry className="robotoCondensed" to={item.link || undefined}>
                      {item.name}
                    </Styled.LinkEntry>
                  )}
                </Styled.AccordionItem>
              ))}
            </Styled.AccordionItemList>
          </Styled.FooterAccordionDetails>
        </Styled.FooterAccordion>
      ))}
    </div>
  )
}

const StyledFooterLinksMobile = styled(FooterLinksMobile)`
  @media (min-width: 992px) {
    display: none;
  }
`

export { StyledFooterLinksMobile as FooterLinksMobile }
